module.exports = __webpack_public_path__ + "img/w3_store_white.9d39a939.png";